import { useState } from "react";
import { useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { Box, Container, Typography, Card, Divider, Link } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { toast } from "react-hot-toast";
import { useDispatch } from "react-redux";
import { resendOtp } from "redux/thunk/auth.thunk";
import Page from "components/Page";
import Astaanta from "assets/logo.png";
import TwoStepAuthenticationForm from "./TwoStepAuthForm";

const RootStyle = styled("div")(({ theme }) => ({
  display: "flex",
  minHeight: "100vh",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: theme.palette.background.default,
  padding: theme.spacing(8, 2),
}));

const CardStyle = styled(Card)(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  padding: theme.spacing(4),
  boxShadow: theme.shadows[4],
  borderRadius: theme.shape.borderRadius * 2,
}));

export default function TwoStepAuthentication() {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const [isSubmitting, setSubmitting] = useState(false);

  const userId = state.userId;

  const sendCodeAgain = async () => {
    try {
      setSubmitting(true);
      const res = await dispatch(resendOtp({ userId }));
      setSubmitting(false);

      if (res.type === "auth/resend-otp/fulfilled") {
        toast.success("Verification code resent successfully.");
      } else {
        toast.error(res?.payload?.response?.data?.error || "Failed to resend OTP");
      }
    } catch (error) {
      setSubmitting(false);
      toast.error(error.message || "An error occurred.");
    }
  };

  return (
    <Page title="Two-Step Authentication">
      <RootStyle>
        <Container>
          <CardStyle>
            <Box sx={{ textAlign: "center", mb: 3 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 3,
                  gap: 2,
                  textAlign: "left",
                }}
              >
                <img
                  src={Astaanta}
                  width={100}
                  height={100}
                  style={{ display: "block" }}
                />
                <Box>
                  <Typography variant="h6" fontWeight="bold">
                    Office of the Auditor General
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    The Federal Republic of Somalia
                  </Typography>
                </Box>
              </Box>

              <Typography variant="h4" gutterBottom>
                Two-Step Authentication
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Please enter the one-time password (OTP) sent to your registered email.
              </Typography>
            </Box>

            <TwoStepAuthenticationForm userId={userId} />

            <Divider sx={{ my: 3 }} />

            <Typography variant="body2" color="text.secondary" align="center">
              Didn’t receive the OTP?{" "}
              <Link
                component="button"
                variant="body2"
                onClick={sendCodeAgain}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Resending..." : "Click here to resend"}
              </Link>
            </Typography>

            <Typography variant="caption" display="block" textAlign="center" mt={1} color="text.secondary">
              If you still have issues, return to the <Link href="/auth/login">login page</Link>.
            </Typography>
          </CardStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}
